'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
// eslint-disable-next-line import/no-default-export
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var triggerEls = context.getElements('.' + context.className + '_Trigger');
  var overlayEls = context.getElements('.' + context.className + '_Overlay');

  triggerEls.forEach(function (trigger) {
    trigger.addEventListener('click', handleClick);
  });

  overlayEls.forEach(function (overlay) {
    overlay.addEventListener('click', handleClose);
  });

  function handleClick(_ref2) {
    var target = _ref2.target;

    var trigger = target.closest('.' + context.className + '_Trigger');
    var mediaId = trigger.dataset.mediaTrigger;
    overlayEls.forEach(function (overlayEl) {
      overlayEl.setAttribute('aria-hidden', overlayEl.dataset.mediaItem !== mediaId);
    });
  }

  function handleClose(_ref3) {
    var target = _ref3.target;

    var overlay = target.closest('.' + context.className + '_Overlay');

    overlay.setAttribute('aria-hidden', true);
  }
}